// 国际手机号输入框
<template>
  <urs-input
  :class="newUp?newup_clazz:old_clazz" ref="input"
  :name="name"
  :placeholder="placeholder"
  :disabled="disabled"
  :type="type"
  :del_icon_clazz="del_icon_clazz"
  @focus="onFocus"
  >
  <div v-show="!newUp" class="u-ic" slot="button" @click="onTogle"><em>+{{selected.code}}</em><i class="btn"></i></div>
  <div class="m-mask"
  v-show="open"
  @click="onChooseC">
    <div ref=countryContainer class="m-pop-ic">
      <ul class="u-country">
          <li><i class="tlt">常用地区</i></li>
          <li v-for="o in common"><i :data-code="o.num"><em :data-code="o.num">+{{o.num}}</em>{{o.cnm}}</i></li>
          <li><i class="tlt">其他地区</i></li>
          <li v-for="o in other"><i :data-code="o.num"><em :data-code="o.num">+{{o.num}}</em>{{o.cnm}}</i></li>
      </ul>
    </div>
  </div>
  </urs-input>
</template>

<script>
import countries from '../assets/country';
export default {
    name: 'urs-mbinput',
    props: {
        name: String,
        placeholder: String,
        disabled: Boolean,
        newUp:Boolean,
        del_icon_clazz: {
            type: String,
            default: 'i-icon i-icon-delete'
        },
        old_clazz:{
            type: String,
            default: 'u-ipt-mob'
        },
        newup_clazz:{
            type: String,
            default: 'u-ipt-mob newup-clazz'
        },
        size: {
            type: String,
            default: 'large'
        }
    },
    data() {
        return {
            type: 'text',
            selected: {
                flag: 'flag-CN',
                code: '86'
            },
            common: countries.common,
            other: countries.other,
            open: false
        };
    },
    computed: {
        value() {
            // 选择中国，不需要前缀
            if (this.selected.code == '86') {
                return this.$refs.input.currentValue;
            } else {
                // 选择其他国家，code-value
                return this.selected.code + '-' + this.$refs.input.currentValue;
            }
        }
    },
    methods: {
        onTogle(event) {
            this.open = true;
        },
        onChooseC(event) {
            let select = event.target.dataset.code;
            if (!!select) {
                this.selected = {
                    code: select,
                    flag: event.target.className
                };
            }
            this.open = false;
        },
        // 校验
        validate() {
            let val = this.$refs.input.currentValue,msg={
               errorMsg:'',
               status:true
            };
            // let flag = true;
            // 中国手机号，严格校验格式
            // 国际手机号，仅校验12位以内纯数字
            // todo 增加1619号段
            if (
                (this.selected.code == '86' &&
                    !/^(13|14|15|16|17|18|19)\d{9}$/.test(val)) ||
                (this.selected.code!=='86' && !( val.indexOf('00') !== 0 && /^\d{3,19}$/.test(this.selected.code + val) ))
            ) {
                msg.status= false;
                msg.errorMsg='手机号码格式错误，请更换后重试';
            }
            return msg;
        },
        onFocus(){
          var parent = this.$parent;
           if(parent&&parent.$options.name=='form-item'){
            parent.setMsg('');
           }
        }
    }
};
</script>

<style lang="scss">
.u-ipt-mob .ipt_wrap {
    padding-left: 1.8rem;
}
.u-ipt-mob.newup-clazz .ipt_wrap{
    padding-left: .2rem;
}
.u-ic {
    position: absolute;
    left: 0.4rem;
    bottom: 0.1em;
    width: 4.5em;
    height: 3em;
    z-index: 11;
    text-align: right;
    font-size: 14px;
    line-height: 2em;
}
.u-ic em {
    position: absolute;
    left: 0;
    display: block;
    height: 2em;
    width: 3em;
    text-align: left;
    margin: 0.4em 0 0 0;
    color: #666666;
}
.u-ic .btn {
    display: block;
    width: 0px;
    height: 0px;
    position: absolute;
    left: 3.2em;
    top: 1.2em;
    border-top: 6px solid #ccc;
    border-bottom: 6px solid white;
    border-left: 6px solid white;
    border-right: 6px solid white;
}
.m-pop-ic {
    width: 80%;
    max-width: 25em;
    height: auto;
    position: relative;
    margin: 0 auto;
    top: 15%;
    height: 70%;
    border-radius: 4px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
    padding: 0.5em 0;
    background: #fff;
    font-size: 14px;
}
.m-pop-ic .u-country {
    background: #fff;
    display: block;
    margin: 0 auto;
    border-radius: 4px;
}
.m-pop-ic .u-country i {
    display: block;
    height: 3em;
    line-height: 3em;
    font-size: 1em;
    color: #464b4d;
    overflow: hidden;
    border-bottom: solid 1px #d0d0d0;
}
.m-pop-ic .u-country i.tlt {
    color: #969696;
    padding-left: 1em;
}
.m-pop-ic em {
    height: 1em;
    width: 1.5em;
    display: block;
    float: left;
    margin: 0 2em 0 2em;
}
em {
    font-size: 14px;
    // background: url('../assets/flags-l.png') no-repeat;
    // background-size: 1.5em 212em;
}
.flag-AL em {
    background-position: 0 0em;
}
.flag-DZ em {
    background-position: 0 -1em;
}
.flag-AF em {
    background-position: 0 -2em;
}
.flag-AR em {
    background-position: 0 -3em;
}
.flag-AE em {
    background-position: 0 -4em;
}
.flag-AW em {
    background-position: 0 -5em;
}
.flag-OM em {
    background-position: 0 -6em;
}
.flag-AZ em {
    background-position: 0 -7em;
}
.flag-EG em {
    background-position: 0 -8em;
}
.flag-ET em {
    background-position: 0 -9em;
}
.flag-IE em {
    background-position: 0 -10em;
}
.flag-EE em {
    background-position: 0 -11em;
}
.flag-AD em {
    background-position: 0 -12em;
}
.flag-AO em {
    background-position: 0 -13em;
}
.flag-AI em {
    background-position: 0 -14em;
}
.flag-AG em {
    background-position: 0 -15em;
}
.flag-AT em {
    background-position: 0 -16em;
}
.flag-AU em {
    background-position: 0 -17em;
}
.flag-BB em {
    background-position: 0 -18em;
}
.flag-PG em {
    background-position: 0 -19em;
}
.flag-BS em {
    background-position: 0 -20em;
}
.flag-PK em {
    background-position: 0 -21em;
}
.flag-PY em {
    background-position: 0 -22em;
}
.flag-PS em {
    background-position: 0 -23em;
}
.flag-BH em {
    background-position: 0 -24em;
}
.flag-PA em {
    background-position: 0 -25em;
}
.flag-BR em {
    background-position: 0 -26em;
}
.flag-BY em {
    background-position: 0 -27em;
}
.flag-BM em {
    background-position: 0 -28em;
}
.flag-BG em {
    background-position: 0 -29em;
}
.flag-BJ em {
    background-position: 0 -30em;
}
.flag-BE em {
    background-position: 0 -31em;
}
.flag-IS em {
    background-position: 0 -32em;
}
.flag-PR em {
    background-position: 0 -33em;
}
.flag-PL em {
    background-position: 0 -34em;
}
.flag-BA em {
    background-position: 0 -35em;
}
.flag-BO em {
    background-position: 0 -36em;
}
.flag-BZ em {
    background-position: 0 -37em;
}
.flag-BW em {
    background-position: 0 -38em;
}
.flag-BT em {
    background-position: 0 -39em;
}
.flag-BF em {
    background-position: 0 -40em;
}
.flag-BI em {
    background-position: 0 -41em;
}
.flag-KP em {
    background-position: 0 -42em;
}
.flag-GQ em {
    background-position: 0 -43em;
}
.flag-DK em {
    background-position: 0 -44em;
}
.flag-DE em {
    background-position: 0 -45em;
}
.flag-TL em {
    background-position: 0 -46em;
}
.flag-TG em {
    background-position: 0 -47em;
}
.flag-DO em {
    background-position: 0 -48em;
}
.flag-DM em {
    background-position: 0 -49em;
}
.flag-RU em {
    background-position: 0 -50em;
}
.flag-EC em {
    background-position: 0 -51em;
}
.flag-ER em {
    background-position: 0 -52em;
}
.flag-FR em {
    background-position: 0 -53em;
}
.flag-FO em {
    background-position: 0 -54em;
}
.flag-PF em {
    background-position: 0 -55em;
}
.flag-GF em {
    background-position: 0 -56em;
}
.flag-PH em {
    background-position: 0 -57em;
}
.flag-FJ em {
    background-position: 0 -58em;
}
.flag-FI em {
    background-position: 0 -59em;
}
.flag-CV em {
    background-position: 0 -60em;
}
.flag-GM em {
    background-position: 0 -61em;
}
.flag-CG em {
    background-position: 0 -62em;
}
.flag-CD em {
    background-position: 0 -63em;
}
.flag-CO em {
    background-position: 0 -64em;
}
.flag-CR em {
    background-position: 0 -65em;
}
.flag-GD em {
    background-position: 0 -66em;
}
.flag-GL em {
    background-position: 0 -67em;
}
.flag-GE em {
    background-position: 0 -68em;
}
.flag-CU em {
    background-position: 0 -69em;
}
.flag-GP em {
    background-position: 0 -70em;
}
.flag-GU em {
    background-position: 0 -71em;
}
.flag-GY em {
    background-position: 0 -72em;
}
.flag-KZ em {
    background-position: 0 -73em;
}
.flag-HT em {
    background-position: 0 -74em;
}
.flag-KR em {
    background-position: 0 -75em;
}
.flag-NL em {
    background-position: 0 -76em;
}
.flag-AN em {
    background-position: 0 -77em;
}
.flag-ME em {
    background-position: 0 -78em;
}
.flag-HN em {
    background-position: 0 -79em;
}
.flag-DJ em {
    background-position: 0 -80em;
}
.flag-KG em {
    background-position: 0 -81em;
}
.flag-GN em {
    background-position: 0 -82em;
}
.flag-GW em {
    background-position: 0 -83em;
}
.flag-CA em {
    background-position: 0 -84em;
}
.flag-GH em {
    background-position: 0 -85em;
}
.flag-GA em {
    background-position: 0 -86em;
}
.flag-KH em {
    background-position: 0 -87em;
}
.flag-CZ em {
    background-position: 0 -88em;
}
.flag-ZW em {
    background-position: 0 -89em;
}
.flag-CM em {
    background-position: 0 -90em;
}
.flag-QA em {
    background-position: 0 -91em;
}
.flag-KY em {
    background-position: 0 -92em;
}
.flag-KM em {
    background-position: 0 -93em;
}
.flag-CI em {
    background-position: 0 -94em;
}
.flag-KW em {
    background-position: 0 -95em;
}
.flag-HR em {
    background-position: 0 -96em;
}
.flag-KE em {
    background-position: 0 -97em;
}
.flag-CK em {
    background-position: 0 -98em;
}
.flag-LV em {
    background-position: 0 -99em;
}
.flag-LS em {
    background-position: 0 -100em;
}
.flag-LA em {
    background-position: 0 -101em;
}
.flag-LB em {
    background-position: 0 -102em;
}
.flag-LT em {
    background-position: 0 -103em;
}
.flag-LR em {
    background-position: 0 -104em;
}
.flag-LY em {
    background-position: 0 -105em;
}
.flag-LI em {
    background-position: 0 -106em;
}
.flag-RE em {
    background-position: 0 -107em;
}
.flag-LU em {
    background-position: 0 -108em;
}
.flag-RW em {
    background-position: 0 -109em;
}
.flag-RO em {
    background-position: 0 -110em;
}
.flag-MG em {
    background-position: 0 -111em;
}
.flag-MV em {
    background-position: 0 -112em;
}
.flag-MT em {
    background-position: 0 -113em;
}
.flag-MW em {
    background-position: 0 -114em;
}
.flag-MY em {
    background-position: 0 -115em;
}
.flag-ML em {
    background-position: 0 -116em;
}
.flag-MK em {
    background-position: 0 -117em;
}
.flag-MQ em {
    background-position: 0 -118em;
}
.flag-MU em {
    background-position: 0 -119em;
}
.flag-MR em {
    background-position: 0 -120em;
}
.flag-US em {
    background-position: 0 -121em;
}
.flag-MN em {
    background-position: 0 -122em;
}
.flag-MS em {
    background-position: 0 -123em;
}
.flag-BD em {
    background-position: 0 -124em;
}
.flag-PE em {
    background-position: 0 -125em;
}
.flag-MD em {
    background-position: 0 -126em;
}
.flag-MA em {
    background-position: 0 -127em;
}
.flag-MC em {
    background-position: 0 -128em;
}
.flag-MZ em {
    background-position: 0 -129em;
}
.flag-MX em {
    background-position: 0 -130em;
}
.flag-NA em {
    background-position: 0 -131em;
}
.flag-ZA em {
    background-position: 0 -132em;
}
.flag-SS em {
    background-position: 0 -133em;
}
.flag-NP em {
    background-position: 0 -134em;
}
.flag-NI em {
    background-position: 0 -135em;
}
.flag-NE em {
    background-position: 0 -136em;
}
.flag-NG em {
    background-position: 0 -137em;
}
.flag-NO em {
    background-position: 0 -138em;
}
.flag-PT em {
    background-position: 0 -139em;
}
.flag-JP em {
    background-position: 0 -140em;
}
.flag-SE em {
    background-position: 0 -141em;
}
.flag-CH em {
    background-position: 0 -142em;
}
.flag-SV em {
    background-position: 0 -143em;
}
.flag-WS em {
    background-position: 0 -144em;
}
.flag-RS em {
    background-position: 0 -145em;
}
.flag-SL em {
    background-position: 0 -146em;
}
.flag-SN em {
    background-position: 0 -147em;
}
.flag-CY em {
    background-position: 0 -148em;
}
.flag-SC em {
    background-position: 0 -149em;
}
.flag-SA em {
    background-position: 0 -150em;
}
.flag-ST em {
    background-position: 0 -151em;
}
.flag-KN em {
    background-position: 0 -152em;
}
.flag-LC em {
    background-position: 0 -153em;
}
.flag-SM em {
    background-position: 0 -154em;
}
.flag-PM em {
    background-position: 0 -155em;
}
.flag-VC em {
    background-position: 0 -156em;
}
.flag-LK em {
    background-position: 0 -157em;
}
.flag-SK em {
    background-position: 0 -158em;
}
.flag-SI em {
    background-position: 0 -159em;
}
.flag-SZ em {
    background-position: 0 -160em;
}
.flag-SD em {
    background-position: 0 -161em;
}
.flag-SR em {
    background-position: 0 -162em;
}
.flag-SO em {
    background-position: 0 -163em;
}
.flag-TJ em {
    background-position: 0 -164em;
}
.flag-TH em {
    background-position: 0 -165em;
}
.flag-TZ em {
    background-position: 0 -166em;
}
.flag-TO em {
    background-position: 0 -167em;
}
.flag-TC em {
    background-position: 0 -168em;
}
.flag-TT em {
    background-position: 0 -169em;
}
.flag-TN em {
    background-position: 0 -170em;
}
.flag-TR em {
    background-position: 0 -171em;
}
.flag-TM em {
    background-position: 0 -172em;
}
.flag-VU em {
    background-position: 0 -173em;
}
.flag-GT em {
    background-position: 0 -174em;
}
.flag-VE em {
    background-position: 0 -175em;
}
.flag-BN em {
    background-position: 0 -176em;
}
.flag-UG em {
    background-position: 0 -177em;
}
.flag-UA em {
    background-position: 0 -178em;
}
.flag-UY em {
    background-position: 0 -179em;
}
.flag-UZ em {
    background-position: 0 -180em;
}
.flag-ES em {
    background-position: 0 -181em;
}
.flag-GR em {
    background-position: 0 -182em;
}
.flag-SG em {
    background-position: 0 -183em;
}
.flag-NC em {
    background-position: 0 -184em;
}
.flag-NZ em {
    background-position: 0 -185em;
}
.flag-HU em {
    background-position: 0 -186em;
}
.flag-SY em {
    background-position: 0 -187em;
}
.flag-JM em {
    background-position: 0 -188em;
}
.flag-AM em {
    background-position: 0 -189em;
}
.flag-YE em {
    background-position: 0 -190em;
}
.flag-IQ em {
    background-position: 0 -191em;
}
.flag-IR em {
    background-position: 0 -192em;
}
.flag-IL em {
    background-position: 0 -193em;
}
.flag-IT em {
    background-position: 0 -194em;
}
.flag-IN em {
    background-position: 0 -195em;
}
.flag-ID em {
    background-position: 0 -196em;
}
.flag-GB em {
    background-position: 0 -197em;
}
.flag-UK em {
    background-position: 0 -198em;
}
.flag-VG em {
    background-position: 0 -199em;
}
.flag-JO em {
    background-position: 0 -200em;
}
.flag-VN em {
    background-position: 0 -201em;
}
.flag-ZM em {
    background-position: 0 -202em;
}
.flag-JE em {
    background-position: 0 -203em;
}
.flag-TD em {
    background-position: 0 -204em;
}
.flag-GI em {
    background-position: 0 -205em;
}
.flag-CL em {
    background-position: 0 -206em;
}
.flag-CF em {
    background-position: 0 -207em;
}
.flag-CN em {
    background-position: 0 -208em;
}
.flag-MO em {
    background-position: 0 -209em;
}
.flag-TW em {
    background-position: 0 -210em;
}
.flag-HK em {
    background-position: 0 -211em;
}
</style>



// WEBPACK FOOTER //
// MbInput.vue?fb15a98e